// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root___2rNuW","contentWrapper":"App__contentWrapper___1_eny","footer":"App__footer___nMaIm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 1027
// module chunks = 0